var map = {
	"./assignment_done.mp3": 6784,
	"./class_end.mp3": 7138,
	"./class_started.mp3": 5300,
	"./coin_added.mp3": 5741,
	"./notes_released.mp3": 1797,
	"./wrong_outcome.wav": 8180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9249;